import {
    FETCH_PIANOTECHAPPOINTMENT_LIST_STARTED,
    FETCH_PIANOTECHAPPOINTMENT_LIST_SUCCEEDED,
    FETCH_PIANOTECHAPPOINTMENT_LIST_FAILED,
    FIND_PIANOTECHAPPOINTMENT_STARTED,
    FIND_PIANOTECHAPPOINTMENT_SUCCEEDED,
    FIND_PIANOTECHAPPOINTMENT_FAILED,
    SAVE_PIANOTECHAPPOINTMENT_STARTED,
    SAVE_PIANOTECHAPPOINTMENT_SUCCEEDED,
    SAVE_PIANOTECHAPPOINTMENT_FAILED,
    RETURN_TO_PIANOTECHAPPOINTMENT_LIST,
    SWITCH_EDIT_TYPE,
    PIANOTECHAPPOINTMENT_MODIFIED,
    PIANOTECHAPPOINTMENT_VALIDATE,
    FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_STARTED,
    FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_SUCCEEDED,
    FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_FAILED,
    PIANOTECHAPPOINTMENT_UPDATE_COMPLETE,
} from '../actions/PianoTechAppointmentActions';

import {
    LOGIN_VALIDATE_USER_SUCCESS,
} from '../actions/LoginActions';

import {
    MESSAGE_TYPE_CONFIRM,
    MESSAGE_TYPE_ERROR,
    MESSAGE_TYPE_INFO,
    VIEW_PIANOTECHAPPOINTMENT_LIST,
    VIEW_PIANOTECHAPPOINTMENT_UPDATE,
    MAINTENANCE_TYPE_COMPLETE,
} from '../app-constants';

const initialState = {
    pianotechappointmentList: [],
    pianotechappointment: null,
    originalPianoTechAppointment: null,
    appointmentsFromDate: [],
    appointmentsFromDateRetrieved: false,
    appointmentsFromDateRetrieveStarted: false,
    view: VIEW_PIANOTECHAPPOINTMENT_LIST,
    appointmentUpdateComplete: false,
};
const reducerOutput = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_PIANOTECHAPPOINTMENT_LIST_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechAppointment list.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechAppointmentList: [],
            }

        case FETCH_PIANOTECHAPPOINTMENT_LIST_SUCCEEDED:

            return {
                ...state,
                pianoTechAppointmentList: action.pianoTechAppointmentList,
                message: 'PianoTechAppointment list successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
            }

        case FETCH_PIANOTECHAPPOINTMENT_LIST_FAILED:

            return {
                ...state,
                pianoTechAppointmentList: [],
                message: 'Error trying to retrieve PianoTechAppointment list.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case RETURN_TO_PIANOTECHAPPOINTMENT_LIST:

            return {
                ...state,
                pianoTechAppointment: null,
                originalPianoTechAppointment: null,
                message: '',
                view: VIEW_PIANOTECHAPPOINTMENT_LIST
            }

        case SWITCH_EDIT_TYPE:

            return {
                ...state,
                maintenanceType: action.maintenanceType,
                title: action.title,
                message: '',
                pianoTechAppointment: action.pianoTechAppointment,
            }

        case FIND_PIANOTECHAPPOINTMENT_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechAppointment.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechAppointment: null,
                maintenanceType: action.maintenanceType,
                title: action.title,
                appointmentUpdateComplete: false,
            }

        case FIND_PIANOTECHAPPOINTMENT_SUCCEEDED:

            return {
                ...state,
                pianoTechAppointment: action.pianoTechAppointment,
                originalPianoTechAppointment: action.originalPianoTechAppointment,
                message: 'PianoTechAppointment successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
                view: VIEW_PIANOTECHAPPOINTMENT_UPDATE,
            }

        case FIND_PIANOTECHAPPOINTMENT_FAILED:

            return {
                ...state,
                pianoTechAppointment: null,
                message: 'Error trying to find PianoTechAppointment.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHAPPOINTMENT_MODIFIED:

            return {
                ...state,
                pianoTechAppointment: action.pianoTechAppointment,
                message: '',
            }

        case SAVE_PIANOTECHAPPOINTMENT_STARTED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_INFO,
            }

        case SAVE_PIANOTECHAPPOINTMENT_SUCCEEDED:

            return {
                ...state,
                pianoTechAppointment: action.pianoTechAppointment,
                message: action.message,
                messageType: MESSAGE_TYPE_CONFIRM,
                maintenanceType: MAINTENANCE_TYPE_COMPLETE,
                appointmentsFromDate: action.pianoTechAppointmentList,
                appointmentUpdateComplete: true,
            }

        case SAVE_PIANOTECHAPPOINTMENT_FAILED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHAPPOINTMENT_VALIDATE:

            return {
                ...state,
                message: action.message,
                messageType: action.messageType,
            }

        case FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechAppointment list for company from date.',
                messageType: MESSAGE_TYPE_INFO,
                appointmentsFromDate: [],
                appointmentsFromDateRetrieveStarted: true,
            }

        case FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_SUCCEEDED:

            return {
                ...state,
                appointmentsFromDate: action.pianoTechAppointmentList,
                appointmentsFromDateRetrieved: true,
                appointmentsFromDateRetrieveStarted: false,
                message: 'PianoTechAppointment list successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
            }

        case FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_FAILED:

            return {
                ...state,
                message: 'Error trying to retrieve PianoTechAppointment list for company from date.',
                messageType: MESSAGE_TYPE_ERROR,
                appointmentsFromDateRetrieved: true,
                appointmentsFromDateRetrieveStarted: false,
            }

        case PIANOTECHAPPOINTMENT_UPDATE_COMPLETE:

            return {
                ...state,
                appointmentUpdateComplete: action.appointmentUpdateComplete,
            }

        case LOGIN_VALIDATE_USER_SUCCESS:

            return {
                ...state,
                appointmentsFromDate: action.pianoTechAppointmentList,
                appointmentsFromDateRetrieved: true,
                appointmentsFromDateRetrieveStarted: false,
            }

        default:
            return state;
    }
}


export default reducerOutput;
